import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getUserFromSession } from "@/utils/auth";

/* 🔹 Simple Skeleton Layout */
const PageSkeleton = () => {
  return (
    <div className="min-h-screen bg-background p-6 animate-pulse">
      {/* Header */}
      <div className="h-8 w-1/3 bg-muted rounded mb-6" />

      {/* Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="h-32 bg-muted rounded-lg" />
        <div className="h-32 bg-muted rounded-lg" />
        <div className="h-32 bg-muted rounded-lg" />
      </div>

      {/* Table */}
      <div className="mt-8 space-y-3">
        <div className="h-4 w-full bg-muted rounded" />
        <div className="h-4 w-5/6 bg-muted rounded" />
        <div className="h-4 w-4/6 bg-muted rounded" />
      </div>
    </div>
  );
};

const ProtectedRoute = ({ children, roles = [] }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const validateSession = async () => {
      try {
        const sessionUser = await getUserFromSession();

        if (sessionUser) {
          setUser(sessionUser);
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
        }
      } catch (err) {
        console.error("Session validation failed:", err);
        setIsAuthenticated(false);
      }
    };

    validateSession();
  }, []);

  // ⏳ Skeleton while validating
  if (isAuthenticated === null) {
    return <PageSkeleton />;
  }

  // ❌ Not logged in
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 🔐 Role-based access control
  if (roles.length > 0 && user) {
    const userRole = (user.role || user.designation || "").toLowerCase();
    const allowedRoles = roles.map((r) => r.toLowerCase());

    if (!allowedRoles.includes(userRole)) {
      return <Navigate to="/" replace />;
    }
  }

  // ✅ Authorized
  return children;
};

export default ProtectedRoute;
